import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserDetailsComponent } from './user-details.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [UserDetailsComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    SharedLayoutModule,
    WithTooltipModule,
    TranslateModule
  ],
  exports: [UserDetailsComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class UserDetailsModule {}
